import { KeyedResource } from './keyed.resource';

export class DrillResource extends KeyedResource {
  private drillNameImpl: string;

  constructor(args: any) {
    super(args, args.drillName);

    this.resourceType = 'drill';
    this.drillNameImpl = this.uiResourceName;
  }

  public get drillName() {
    return this.drillNameImpl;
  }
}
